// Billing config shared between frontend and backend (mirrors backend/billing.py)
export const STRIPE_CONFIGURED = false; // Overridden at runtime by env check

export const PLAN_BY_LOOKUP = {
  starter_monthly: "starter",
  pro_monthly: "pro",
  multi_monthly: "multi",
};

export const PLAN_PRICES_NZD = {
  starter: 99,
  pro: 199,
  multi: 499,
};
